<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <div style="margin-bottom: 15px;">
      <label>Did your affiliate earn any income with respect to activities in or involving any of the following countries?</label>
      <div style="margin: 5px 0 10px 20px;">
        <label style="margin-right: 15px;"><span class="circle"></span> Syria (SY)</label>
        <label style="margin-right: 15px;"><span class="circle"></span> Iran (IR)</label>
        <label style="margin-right: 15px;"><span class="circle"></span> Sudan (SU)</label>
        <label><span class="circle"></span> North Korea (KN)</label>
      </div>
      <div>
        <label style="margin-right: 15px;">
          <input type="radio" name="sanctioned" value="Y" [(ngModel)]="sanctionedCountry"> Yes
        </label>
        <label>
          <input type="radio" name="sanctioned" value="N" [(ngModel)]="sanctionedCountry"> No
        </label>
      </div>
    </div>

    <div style="margin-bottom: 10px;">
      <label>If Yes, a representative from Corporate Taxes will follow up with you to gather specific information.</label>
    </div>

    <div style="margin-bottom: 15px;">
      <label>Did your affiliate make any payments which would violate the U.S. Foreign Corrupt Practices Act ("FCPA") if the FCPA had been applicable to the affiliate?</label>
      <div style="margin-top: 5px;">
        <label style="margin-right: 15px;">
          <input type="radio" name="illegal" value="Y" [(ngModel)]="illegalPayments"> Yes
        </label>
        <label>
          <input type="radio" name="illegal" value="N" [(ngModel)]="illegalPayments"> No
        </label>
      </div>
    </div>

    <div class="fcpa-info">
      <p>In connection with the preparation of the consolidated Federal income tax return, we must determine
        whether any foreign subsidiary made payments which must be treated by its U.S. parent corporation as
        Subpart F income under the U.S. tax law.</p>
      <p>A payment by the foreign subsidiary will give rise to Subpart F (deemed dividend) income to the U.S.
        parent if: (1) the foreign subsidiary is classified under the U.S. tax law as a controlled foreign
        corporation ("CFC"), and (2) the payment by the foreign subsidiary would have been unlawful under the
        Foreign Corrupt Practices Act ("FCPA") had the FCPA been applicable to that subsidiary.</p>
      <p><strong>A response is needed for all CFCs, negative or positive.</strong></p>
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="save()" [disabled]="crudLoading">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
